<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch7">
<div class="chapterHead">
<p class="centerImage0"><img alt="image" src="images/ch7.jpg" width="5%"/></p>
</div>
<p class="para" style="text-indent: 5%;"><a id="pg-7">You stare at the thing under the covers. Your heart beats triple time.</a></p><a id="pg-7">
<p class="para" style="text-indent: 5%;">What is it? A boy? A dog?</p>
<p class="para" style="text-indent: 5%;">Or a little bit of each?</p>
<p class="para" style="text-indent: 5%;">“Help me,” he says again. “Please. My name is Joseph. Dr. Eeek tried to turn me into a German shepherd, but it didn’t work. So now he’s trying to turn me back into a kid.”</p>
<p class="para" style="text-indent: 5%;">You don’t know what to say. This is so creepy — so sick! How could your mother work in a place like this?</p>
<p class="para" style="text-indent: 5%;">“I’m strapped down,” the boy explains. He gestures toward his hairy, doggy arms. “Loosen the straps so I can get free.”</p>
<p class="para" style="text-indent: 5%;">“Okay,” you say. Your stomach lurches at the sight of bristly dog hair all over this kid’s body.</p>
<p class="para" style="text-indent: 5%;">You start to undo the straps. But before you can finish, you hear footsteps approaching.</p>
<p class="para" style="text-indent: 5%;">Quick! You’d better find a place to hide!</p>
</a><p class="extractLetterText" style="text-indent: 5%;"><a id="pg-7"><em class="italic">If you hide in Dr. Eeek’s office on the other side of the room, turn to</em> </a><span href="#/e9780545841054_ch129" title="Link target outside of Sample"><em class="italic">PAGE 129</em></span>.</p>
<p class="para" style="text-indent: 5%;"><em class="italic">If you hide under the operating table, turn to</em> <span href="#/e9780545841054_ch074" title="Link target outside of Sample"><em class="italic">PAGE 74</em></span>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9780545841054_ch007.vue?42d0a9b9